import React, { SVGProps } from 'react';


const SvgLogout = (props: SVGProps<SVGSVGElement>) => {



  return (
    <svg
      viewBox='0 0 24 24'
      fill='currentColor'
      className='svg-icon'
     
      style={{ cursor: 'pointer' }} 
      {...props}
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5zm16 7l-4-4v3H9v2h8v3l4-4z' />
    </svg>
  );
};

export default SvgLogout;
